import {OrderItemArray} from '~/app/core/common/models/orderItemArray';

export class OrderItemInsert {
    trackingId: number;
    custId: string;
    orderItems: OrderItemArray[] = [];
}

